Ext.define('SA.view.ImportFileStep', {
    alias: 'widget.import-file-step',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-import-file-step',

    items: [
        {
            xtype: 'import-country-section',
            cls: 'sa-import-file-step-country-section',
            itemId: 'countrySection'
        }, {
            xtype: 'component',
            cls: 'sa-import-file-step-file-list-label',
            html: 'Please select a CSV file to import:'
        }, {
            xtype: 'import-file-list',
            cls: 'sa-import-file-step-file-list',
            itemId: 'fileList'
        }, {
            xtype: 'component',
            cls: 'sa-import-file-step-add-file-link',
            html: '+ Add another geographic unit',

            autoEl: {
                tag: 'a',
                href: '#'
            }
        }, {
            xtype: 'component',
            cls: 'sa-import-file-step-dataset-name-text-field-label',
            itemId: 'datasetNameTextFieldLabel',

            html: [
                '<span class="sa-import-file-step-dataset-name-text-field-label-bold">',
                    'What is the name of this dataset? ',
                '</span>',
                'This is the name that will be displayed in SimplyAnalytics.'
            ]
        }, {
            xtype: 'sa-text-field',
            cls: 'sa-import-file-step-dataset-name-text-field',
            itemId: 'datasetNameTextField',
            height: 40,
            maxLength: 100,
            width: 320
        }, {
            xtype: 'component',
            cls: 'sa-import-file-step-dataset-name-text-field-label-clone-target',
            itemId: 'datasetNameTextFieldLabelCloneTarget'
        }
    ],

    initComponent() {
        this.callParent();

        this.countrySection = this.down('#countrySection');
        this.fileList = this.down('#fileList');
        this.datasetNameTextField = this.down('#datasetNameTextField');
        this.datasetNameTextFieldLabel = this.down('#datasetNameTextFieldLabel');
        this.datasetNameTextFieldLabelCloneTarget = this.down('#datasetNameTextFieldLabelCloneTarget');

        this.countrySection.setVisible(!SA.Institution.isSingleCountry());

        this.refreshFileListGeographicUnits();
    },

    getFileCount() {
        return this.fileList.getValue().filter(({file}) => file !== null).length;
    },

    async getValue() {
        var countryCode = this.countrySection.getValue(),
            datasetName = this.datasetNameTextField.getValue().trim(),
            tuples = await this.fileList.getValue();

        return {countryCode, datasetName, tuples};
    },

    initEvents() {
        this.callParent();

        this.countrySection.on('change', this.onCountryChange, this);
        this.fileList.on('change:itemCount', this.onFileListItemCountChange, this);

        this.el.on({
            delegate: '.sa-import-file-step-add-file-link',
            click: () => this.onAddItemClick(),
            preventDefault: true
        });
    },

    onAddItemClick() {
        this.fileList.addItem();
    },

    onCountryChange() {
        this.refreshFileListGeographicUnits();
    },

    onFileListItemCountChange() {
        this.fireEvent('change:fileItemCount');
    },

    refreshFileListGeographicUnits() {
        var project = SA.AppController.getCurrentProject(),
            selectedCountry = this.countrySection.getValue(),
            units;

        if (selectedCountry === project.getCountry()) {
            units = project.getDiscoverableGeographicUnits();
        }
        else {
            units = SA.data.GeographicUnits.getFixedDiscoverableUnitsForCountry(selectedCountry);
        }

        this.fileList.setGeographicUnits(SA.data.GeographicUnits.get(units));
    },

    resizeWithConstraint({maxHeight}) {
        var me = this,
            width = getContentWidth() + getPaddingWidth() + Ext.getScrollbarSize().width;

        this.el.setStyle({
            maxHeight: `${maxHeight}px`,
            width: `${width}px`
        });

        function getPaddingWidth() {
            var {paddingLeft, paddingRight} = window.getComputedStyle(me.el.dom);

            return parseFloat(paddingLeft) + parseFloat(paddingRight);
        }

        function getContentWidth() {
            var target = me.datasetNameTextFieldLabelCloneTarget.el.dom,
                clone = me.datasetNameTextFieldLabel.el.dom.cloneNode(true);

            clone.setAttribute('id', null);
            clone.style.width = null;

            target.innerHTML = '';
            target.appendChild(clone);

            return Ext.fly(clone).getWidth();
        }
    }
});
